(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fiberglass-free-content"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glaciotex-upsell-standard-content"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kids-staggered-content--bear-2"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kids-staggered-content--bear"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natural-staggered-content--hybrid"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-staggered-content"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-staggered-content"]) return;
  try {
    
  $(document).ready(function () {
    var vids = $('.staggered_video');
    $.each(vids, function () {
      this.controls = false;
    });
    $('.staggered_video').on('click', function () {
      var video = $(this).children('video')[0];
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-staggered-content"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--adjBase-2"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--adjBase"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--adjustable-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-2-h-pro-hybrid"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-2-h"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-2"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-original-v2"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-pillow-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-pro-2"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-pro-3"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-pro-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-pro"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-v2-pro-hybrid"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear-v2"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bear"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--bearmattress-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--blanket-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--chevron-bed"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--closeout"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--cloud-pillows-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--compare"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--contact"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--encasement-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--firmness"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--foundation-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--foundation"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--frame-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--free-gift"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--hybrid-elite"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--hybrid-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--hybrid"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--hybrid2019"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--mattress"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--military"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--mini-pillow"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--platform-bed"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--pro-topper"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--protector-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--removal"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--reviews"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--rv"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--sale-page-1"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--sale-page"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--shipping-2"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--shipping"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--showroom"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--sleep-bundle"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--teachers"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--tech"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--topper-review"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--upholstered-bed"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content--white-glove"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content-black-friday"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content-collection-mattresses"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content-collection-rv-mattresses"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-content"]) return;
  try {
    
  $(document).ready(function () {
    var vids = $('.staggered_video');
    $.each(vids, function () {
      this.controls = false;
    });
    $('.staggered_video').on('click', function () {
      var video = $(this).children('video')[0];
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-staggered-content--hybrid"]) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tnp-staggered-content"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    var vids = $('.staggered_video'); 
    $.each(vids, function(){
      this.controls = false; 
    });
    $('.staggered_video').on("click", function() {
      var video=$(this).children("video")[0];
      if( video.paused ) 
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
